import { Component } from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    errorFallback: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  }

  state = {
    hasError: false,
    error: null,
    errorInfo: null,
  }

  static getDerivedStateFromError(error) {
    return { hasError: Boolean(error) }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    })
  }

  render() {
    if (this.state.hasError) {
      if (typeof this.props.errorFallback === 'function') {
        return this.props.errorFallback(this.state.error, this.state.errorInfo)
      }
      return this.props.errorFallback
    }
    return this.props.children
  }
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ErrorBoundary/index.js